import PropTypes from 'prop-types';
import BrazilianResidentIDHelper from '../../helpers/BrazilianResidentIDHelper';
import DetailedTooltip from '../DetailedTooltip';

export function BrazilianResidentIDTooltip(props) {
  return (
    <DetailedTooltip title="checkout.address.field.label.cpfBrazil.helpContent.title" tooltipID={props.tooltipID}>
      <BrazilianResidentIDHelper />
    </DetailedTooltip>
  );
}

BrazilianResidentIDTooltip.propTypes = {
  tooltipID: PropTypes.string.isRequired,
};

export default BrazilianResidentIDTooltip;
